/**
 * Talent detail modal — opens for any [data-talent-card] click.
 * Markup lives in snippets/talent-modal.liquid; cards describe themselves
 * via data-talent-* attributes (see the snippet header for the contract).
 * Modifier/middle clicks and external links inside a card keep native
 * behavior; without JS the cards remain plain links.
 */
(function () {
  'use strict';

  if (window.__nsTalentModalInit) return; /* sections may render the snippet twice */
  window.__nsTalentModalInit = true;

  function init() {
    var modal = document.querySelector('[data-talent-modal]');
    if (!modal || typeof modal.showModal !== 'function') return;

    var img = modal.querySelector('[data-talent-modal-img]');
    var title = modal.querySelector('[data-talent-modal-title]');
    var group = modal.querySelector('[data-talent-modal-group]');
    var desc = modal.querySelector('[data-talent-modal-desc]');
    var socials = modal.querySelector('[data-talent-modal-socials]');
    var products = modal.querySelector('[data-talent-modal-products]');
    var cta = modal.querySelector('[data-talent-modal-cta]');
    var aboutSection = modal.querySelector('[data-talent-modal-about]');
    var followSection = modal.querySelector('[data-talent-modal-follow]');
    var shopSection = modal.querySelector('[data-talent-modal-shop]');

    function setLine(el, text) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    }

    function populate(card) {
      modal.style.setProperty('--tm-accent', card.getAttribute('data-talent-accent') || 'var(--color-neon-cyan)');
      setLine(title, card.getAttribute('data-talent-title'));
      setLine(group, card.getAttribute('data-talent-group'));

      /* About section */
      var bio = card.getAttribute('data-talent-desc') || '';
      if (desc) desc.textContent = bio;
      if (aboutSection) aboutSection.hidden = !bio;

      /* Image: drop the previous talent's bitmap immediately and only fade
         the new one in once it has loaded — otherwise the old photo shows
         for a moment while the new one decodes. */
      var imgUrl = card.getAttribute('data-talent-img');
      if (img) {
        img.classList.remove('is-loaded');
        img.removeAttribute('src');
        if (imgUrl) {
          img.hidden = false;
          img.alt = card.getAttribute('data-talent-title') || '';
          img.onload = function () {
            img.classList.add('is-loaded');
          };
          img.src = imgUrl;
          if (img.complete && img.naturalWidth > 0) {
            /* Cached image — load may not fire again */
            img.classList.add('is-loaded');
          }
        } else {
          img.hidden = true;
        }
      }

      /* Socials section — clone the card's ready-made links, if any */
      var tpl = card.querySelector('template[data-talent-socials]');
      if (socials) {
        socials.innerHTML = '';
        if (tpl) socials.appendChild(tpl.content.cloneNode(true));
      }
      if (followSection) followSection.hidden = !tpl;

      /* Merch section — collection item preview + shop CTA. Template images
         are inert until cloned, so fade each in as it loads (over a shimmer
         placeholder) instead of letting them pop in. */
      var productsTpl = card.querySelector('template[data-talent-products]');
      if (products) {
        products.innerHTML = '';
        if (productsTpl) {
          products.appendChild(productsTpl.content.cloneNode(true));
          products.querySelectorAll('.talent-modal__product-media').forEach(function (media) {
            var im = media.querySelector('img');
            if (!im) {
              media.classList.add('is-loaded'); /* imageless: stop the shimmer */
              return;
            }
            var done = function () { media.classList.add('is-loaded'); };
            if (im.complete && im.naturalWidth > 0) {
              done();
            } else {
              im.addEventListener('load', done);
              im.addEventListener('error', done);
            }
          });
        }
        products.hidden = !productsTpl;
      }

      var url = card.getAttribute('data-talent-url');
      var hasUrl = url && url !== '#';
      if (cta && hasUrl) cta.href = url;
      if (cta) cta.hidden = !hasUrl;
      if (shopSection) shopSection.hidden = !hasUrl && !productsTpl;
    }

    /* Warm a card's modal images on hover/touch intent, so they're already
       cached by the time the modal opens. Template contents don't load on
       their own, hence the explicit prefetch. */
    function warmCard(card) {
      if (card.__nsWarmed) return;
      card.__nsWarmed = true;

      var urls = [];
      var hero = card.getAttribute('data-talent-img');
      if (hero) urls.push(hero);
      var tpl = card.querySelector('template[data-talent-products]');
      if (tpl) {
        tpl.content.querySelectorAll('img[src]').forEach(function (im) {
          urls.push(im.getAttribute('src'));
        });
      }
      urls.forEach(function (url) {
        var pre = new Image();
        pre.src = url;
      });
    }

    document.addEventListener('pointerover', function (e) {
      var card = e.target.closest && e.target.closest('[data-talent-card]');
      if (card) warmCard(card);
    });

    document.addEventListener('touchstart', function (e) {
      var card = e.target.closest && e.target.closest('[data-talent-card]');
      if (card) warmCard(card);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-talent-card]');
      if (card) {
        /* Keep native behavior for modifier clicks and for external links
           (e.g. social icons shown on the card itself) */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        if (e.target.closest('a[target="_blank"]')) return;

        e.preventDefault();
        populate(card);
        modal.showModal();
        return;
      }

      if (modal.open) {
        if (e.target.closest('[data-talent-modal-close]') || e.target === modal) {
          modal.close();
        }
      }
    });
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
